(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-filters-drawer"]) return;
  try {
    
  const resultsSectionWrapper = document.querySelector('.book-list')?.closest('.shopify-section');
  const drawerFacetsForm = document.querySelector('#header-filters-drawer facets-form-component');

  if (resultsSectionWrapper && drawerFacetsForm) {
    drawerFacetsForm.setAttribute('section-id', resultsSectionWrapper.id.replace(/^shopify-section-/, ''));
  }

  const navigateFacets = (triggerElement, url) => {
    const facetsForm = triggerElement.closest('facets-form-component');
    if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
      facetsForm.updateFiltersByURL(url);
    } else {
      window.location.href = url;
    }
  };

  document.addEventListener('click', (event) => {
    const resetButton = event.target.closest('.header-filters-drawer__search-reset');
    if (!resetButton) return;

    const targetUrl = new URL(resetButton.dataset.resetUrl, window.location.origin);
    const params = new URLSearchParams(window.location.search);
    params.delete('q');
    targetUrl.search = params.toString();

    navigateFacets(resetButton, targetUrl.toString());
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.header-filters-drawer__search-form');
    if (!form) return;

    event.preventDefault();

    const input = form.querySelector('.header-filters-drawer__search-input');
    let query = (input?.value ?? '').trim();
    // Bare ISBN: Shopify treats a digits-only query as a barcode lookup, not a
    // text search, so it misses the Flow-written `isbn: <digits>` tags. Send
    // `ISBN <digits>` instead (see docs/specs/search-mirror-tags.md).
    if (/^[\d\s-]+$/.test(query) && query.replace(/\D/g, '').length >= 8) {
      query = `ISBN ${query.replace(/[\s-]+/g, '')}`;
    }
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('type', 'product');

    navigateFacets(form, `${form.action.split('?')[0]}?${params.toString()}`);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
